export default "__VITE_ASSET__CrwQBaYn__"